import { useState } from 'react'
import { EasyIcon } from 'src/components'

const PWDCol = (props: { text: string }) => {
  const [visible, setVisible] = useState(false)
  return (
    <div onClick={() => setVisible(!visible)} style={{ minWidth: 340 }}>
      <span>{visible ? props.text : props.text.replace(/./g, '*').slice(0, 6)}</span>
      <EasyIcon
        type={visible ? 'EyeInvisibleOutlined' : 'EyeOutlined'}
        className='cursor-pointer pd-l8'
      />
    </div>
  )
}

export default {
  renderPWD (text: any, record: any, ListTableContext: any) {
    return <PWDCol text={text} />
  },
}